import { React, useEffect, useState, useContext } from "react";
import { MyContextProvider } from "../../../../App"
import axios from "axios";
import { API_URL } from "../../../../Constant";
import { GlobalLoading, showLoading } from "react-global-loading";
import { ToastContainer, toast } from "react-toastify";
import { handleUserLevelAccessPermissions, validateRolesIIPHQ } from "../../../../Custom/Custom";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { generateExcelASITable2 } from "../../../../Custom/ASIReport/PendencyReport/ExportaPendencyReportExcel";
import messages from '../../../../assets/Messages.json';
import asiTitle from '../../../../asi.json';

const Table2Report = () => {
    const [year,setYear]=useState([]); 
    const [yearName, setYearName] = useState("");
    const [tableReportData, setTableReportData] = useState([]);
    const [buttonAccess, setButtonAccess] = useState({
        userLevel: "",
        roles: "",
        isVisible: false,
    });
    const [yearNameNextTitle, setYearNameNextTitle] = useState([]);
    const token = useContext(MyContextProvider).token;
    const decode_token = jwtDecode(token);
    const navigate = useNavigate();
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };


    const storedLanguage = localStorage.getItem('language');

   



    //get Years 

    const getSurveyYears=async()=>{
        showLoading(true)
           try {
              const response = await axios.get(`${API_URL}api/asi/surveyYearList`, config);
              const allYear = response.data;
              if (allYear.status) {
                  setYear(allYear.data.surveyYearList.reverse())
                  showLoading(false);
              }
        } catch (error) {
           console.error(error);
           showLoading(false);
        }finally{
           showLoading(false);
        }
      
      }

 

    useEffect(() => {
        const level = handleUserLevelAccessPermissions(decode_token);
        setButtonAccess(level);
        getSurveyYears()
      }, []);



    const handleDropdownChange = (e) => {
        setYearName(e.target.value);
      };


      const downloadStaticTable2Xlsx = async () => {
        const fileUrl = `pdf/ASI_Table2.xlsx`;
        try {
          const response = await fetch(fileUrl);
          if (!response.ok) {
            throw new Error("File not found");
          }
          const blob = await response.blob();
          const objectUrl = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = objectUrl;
          link.download = "ASI_Table2.xlsx";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(objectUrl);
        } catch (error) {
          console.error(error);
          toast.error("File not found", messages.COLOR_RED);
        } finally {
          showLoading(false);
        }
      };
    const handleGenerateExcel = () => {
        if (!yearName) {
          toast.error("Please select a Survey Year", messages.COLOR_RED);
          return;
        }
    
        showLoading(true);
        // Prepare payload
        const payload = {
          survey_year: yearName,
        };
        if (String(yearName) === "2023") {
          downloadStaticTable2Xlsx();
          return false;
        }
    
        // POST request to API
        axios
            .post(`${API_URL}api/asi/reports/HQReports/asigetTable2Report`, payload, config)
            .then((response) => {
                // Handle success and generate the Excel file directly
                const table2Report = response.data.data.asigetTable2DSLReportdata;

                if (!table2Report || table2Report.length === 0) {
                    toast.error("Data not found",messages.COLOR_RED);
                    showLoading(false);
                    return;
                  }
    
                let excelFileName = 'ASI_Table2';
                let firstRowMergeCells = "A1:U1";
                let secondRowMergeCells = "A2:U2";
                let thirdRowMergeCells = "A3:U3";

                if (String(yearName) === "2023") {
                  firstRowMergeCells = "A1:AJ1";
                  secondRowMergeCells = "A2:AJ2";
                  thirdRowMergeCells = "A3:AJ3";
                }

                const excelObjectData = {
                  fileName: excelFileName,
                  reportType: excelFileName,
                  fileType: 'xlsx',
                  sheetName: "ASI_Table2",
                  firstRowMergeCells,
                  firstRowExportData: 'सारिणी -२',
                  firstRowCellNumber: 15,
                  secondRowMergeCells,
                  secondRowText: `वार्षिक उद्योग सर्वेक्षण ${yearName}`,
                  yearName,
                  thirdRowMergeCells,
                  thirdRowText: 'उत्तर प्रदेश के विभिन्न उद्योगों में लगी विनियोजित पूँजी , आगत, निर्गत , उत्पादन एवं शुद्ध आवर्धित मूल्य आदि का विवरण ',
                  headerHindiColumns: [
                    'Industry Code', 'Description', 'Weight', 'April', 'May', 'June', 'July', 'August', 'Sept', 'Oct', 'Nov', 'Dec'
                  ],
                };

                const numOrZero = (v) =>
                  v === null || v === undefined || v === "" ? 0 : v;

                const mapTable2Row2023 = (item) => [
                  item.division_code ?? item.DIVISION_CODE ?? "",
                  item.district_code ?? item.DISTRICT_CODE ?? "",
                  item.nicCodePerframe ?? "",
                  numOrZero(item.registered ?? item.No_Of_Factories),
                  numOrZero(item.totalWorking ?? item.Factories_In_operation ?? item.working),
                  numOrZero(item.totalEstimated ?? item.estimated),
                  numOrZero(item.fixedCapital ?? item.permanentCapital),
                  numOrZero(item.physicalWorkingCapital),
                  numOrZero(item.workingCapital ?? item.capitalEmployed),
                  numOrZero(item.investedCapital),
                  numOrZero(item.grossValueofadditionstofixedCapital),
                  numOrZero(item.rentPaid ?? item.RentPaid),
                  numOrZero(item.outstandingLoan ?? item.Outstanding_Loan),
                  numOrZero(item.interestPaid ?? item.Interestpaid),
                  numOrZero(item.rentReceived ?? item.Rentreceived),
                  numOrZero(item.interestReceived ?? item.InterestReceived),
                  numOrZero(item.grossValueofPM ?? item.GrossValueofPM),
                  numOrZero(
                    item.valueofProductsByProducts ??
                      item.ValueofProductsAndByProducts ??
                      item.valueOfProduction
                  ),
                  numOrZero(item.otherOutput ?? item.OtherOutput),
                  numOrZero(item.tatalOutput ?? item.TotalOutput ?? item.totalOutput),
                  numOrZero(item.fuelsConsumed ?? item.Fuelsconsumed),
                  numOrZero(
                    item.materialsConsumedforManufacturing ??
                      item.MaterialsConsumedForManufacturing ??
                      item.consumables
                  ),
                  numOrZero(item.otherInput1 ?? item.OtherInput),
                  numOrZero(item.tatalOutput1 ?? item.TotalInput ?? item.totalInput),
                  numOrZero(item.gva ?? item.GVA ?? item.grossAddedValue),
                  numOrZero(item.depreciation ?? item.Depreciation),
                  numOrZero(item.nva ?? item.NVA ?? item.netAddedValue),
                  numOrZero(
                    item.netFixedCapitalFormationNFCF ??
                      item.NetFixedCapitalFormation ??
                      item.netFixedCapitalFormation
                  ),
                  numOrZero(
                    item.grossFixedCapitalFormationGFCF ??
                      item.GrossFixedCapitalFormation ??
                      item.grossFixedCapitalFormation
                  ),
                  numOrZero(item.materialsFuelsetc ?? item.MaterialsFuelsEtc),
                  numOrZero(item.semiFinishedGoods ?? item.SemiFinishedGoods),
                  numOrZero(item.finishedGoods ?? item.FinishedGoods),
                  numOrZero(item.total ?? item.Total),
                  numOrZero(item.grossCapitalFormation ?? item.GrossCapitalFormation),
                  numOrZero(
                    item.netincome ??
                      item.Netincome ??
                      item.NetIncome ??
                      item.netIncome
                  ),
                  numOrZero(item.profit ?? item.Profit ?? item.benefit),
                ];

                const transformedData = table2Report.map((item) => {
                  if (String(yearName) === "2023") {
                    return mapTable2Row2023(item);
                  }
                  return [
                    item.DIVISION_CODE === "" ? '0' : item.DIVISION_CODE,
                    item.DISTRICT_CODE === "" ? '0' : item.DISTRICT_CODE,
                    item.nicCodePerframe === "" ? '0' : item.nicCodePerframe,
                    item.registered === "" ? '0' : item.registered,
                    item.working === "" ? '0' : item.working,
                    item.estimated === "" ? '0' : item.estimated,
                    item.permanentCapital === "" ? '0' : item.permanentCapital,
                    item.physicalWorkingCapital === "" ? '0' : item.physicalWorkingCapital,
                    item.capitalEmployed === "" ? '0' : item.capitalEmployed,
                    item.consumables === "" ? '0' : item.consumables,
                    item.totalInput === "" ? '0' : item.totalInput,
                    item.totalOutput === "" ? '0' : item.totalOutput,
                    item.valueOfProduction === "" ? '0' : item.valueOfProduction,
                    item.grossAddedValue === "" ? '0' : item.grossAddedValue,
                    (item.depreciation ?? item.Depreciation) === ""
                      ? "0"
                      : item.depreciation ?? item.Depreciation ?? "0",
                    item.netAddedValue === "" ? '0' : item.netAddedValue,
                    item.netFixedCapitalFormation === "" ? '0' : item.netFixedCapitalFormation,
                    item.grossFixedCapitalFormation === "" ? '0' : item.grossFixedCapitalFormation,
                    (item.netincome ??
                      item.Netincome ??
                      item.NetIncome ??
                      item.netIncome) === ""
                      ? "0"
                      : item.netincome ??
                          item.Netincome ??
                          item.NetIncome ??
                          item.netIncome ??
                          "0",
                    item.benefit === "" ? '0' : item.benefit,
                    item.grossCapitalFormation === "" ? '0' : item.grossCapitalFormation,
                  ];
                });
                excelObjectData.excelRowData = transformedData;
    
                generateExcelASITable2(excelObjectData);
    
                showLoading(false);
            })
            .catch((error) => {
                console.error('API Error:', error);
                showLoading(false);
            });
    };
    

    return (
        <>
            <GlobalLoading />
            <ToastContainer />
            <div className="container-fluid py-3">
                <div className="card mx-3 mb-3">
                    <div className="card-body pb-1">
                        <div className="row align-items-center">
                            <h4 className="page_heading">
                            <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.TABLE_TWO_REPORT : asiTitle.en.TABLE_TWO_REPORT }} />
                             </h4>

                            <div className="row align-items-center">

                                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                                    <label className="fw-bold h6">
                                    {storedLanguage === 'hi' ? asiTitle.hi.SURVEY_YAER : asiTitle.en.SURVEY_YAER}
                                     </label>
                                    <select
                                        name="year_name"
                                        className="form-select"
                                        onChange={handleDropdownChange}
                                        value={yearName}
                                    >
                                        <option value="" disabled>
                                            Select Year
                                        </option>
                                        {year
                                        .sort((a, b) => b - a) 
                                        .map((yearName, index) => (
                                            <option key={index} value={yearName}>
                                            {yearName}-{(parseInt(yearName) + 1).toString().slice(2)}
                                            </option>
                                        ))}

                                    </select>
                                </div>

                                <div className="col-xl-2 col-lg-12 mb-3">
                                    <label className="w-100 d-none d-sm-block">&nbsp;</label>
                                    <button onClick={handleGenerateExcel} className="btn btn_orange">Get Report</button>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}

export default Table2Report